module.exports = __webpack_public_path__ + "img/Union.fa217073.svg";